import styled from '@emotion/styled';
import useTableStore from "../../../store/table";

// context
import { useTableId } from "../../../contexts/TableId";

import FilterChip from "./FilterFormComponents/FilterChip";

import { BasicFlex } from '../../Common';

import { isEmpty } from 'lodash';

const Gutter = styled.div`
  height: 2.5rem;
`;


const FilterRibbon = ({ filters }) => {
  const tableId = useTableId();
  const activeFilters = useTableStore(state => state.tableFilters[tableId]) || {};

  return (
    isEmpty(activeFilters) ? <Gutter /> : 
    <BasicFlex my="1rem" justify="flex-start" gap="1rem">
      {Object.keys(activeFilters).map((el) => {
        let label = filters.find(cur => cur.id === el).label
        let obj = activeFilters[el]
        
        return (
          <FilterChip key={el} id={el} filter={obj} label={label} />
          );
      })}
    </BasicFlex>
  )
};

export default FilterRibbon;
